import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Link} from "react-router-dom";
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import axios from 'axios';

import UserLoginService from '../../components/2.0/_services/user/UserLoginService';
import NetworkSubscriptionMessageService from "../../components/2.0/_services/network/NetworkSubscriptionMessageService";

const LoginPage = (props) => {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const validate = (data) => {
    let errors = {};
    if (!data.username) {
      // errors.username = 'Az email mező nem lehet üres.';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.username)) {
      errors.username = 'Mindenképpen email formátumra van szükség! Pl. example@email.com';
    }
    if (!data.password) {
      // errors.password = 'A jelszó nem lehet üres';
    }
    return errors;
  };

  const onSubmit = (data, form) => {
    setLoginError(false);
    setLoading(true)
    // setFormData(data);
    UserLoginService(data)
      .then(response => {
        localStorage.setItem("userToken", response.data.token);
        localStorage.setItem("refreshToken", response.data.refresh_token);
        localStorage.setItem("refreshTokenExpiration", response.data.refresh_token_expiration);
        if (response.data.refresh_token) {
          localStorage.setItem("refreshToken", response.data.refresh_token);
        }
        if (response.data.refresh_token_expiration) {
          localStorage.setItem("refreshTokenExpiration", String(response.data.refresh_token_expiration));
        }
        if (window.App && typeof window.App.setupAutoLogout === 'function') {
          window.App.setupAutoLogout();
        }
        let resBase64 = response.data.token.substring(
          response.data.token.indexOf(".") + 1,
          response.data.token.lastIndexOf(".")
        );
        // let res = atob(resBase64)
        // let resJson = JSON.parse(res)
        let resJson = JSON.parse(decodeURIComponent(escape(atob(resBase64))));
        localStorage.setItem("userId", resJson.id);
        localStorage.setItem("userName", resJson.username);
        localStorage.setItem("userRealName", resJson.name);
        localStorage.setItem("userEmail", data.username);
        localStorage.setItem("roles", JSON.stringify(resJson.roles).toLowerCase())
        axios.get(process.env.REACT_APP_API_HOST + '/api/v2/networks', {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          }
        })
          .then(response => {
            if (response.data && response.data[0]) {
              window.App.setState({
                networks: response.data
              })
              localStorage.setItem('networkId', response.data[0].id)
              localStorage.setItem('networkName', response.data[0].name)
            }
            axios.get(process.env.REACT_APP_API_HOST + '/api/v2/modules', {
              headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
                'App-Network': localStorage.getItem('networkId') || ''
              }
            })
              .then(response => {
                Object.entries(response.data).map(function (item, index) {
                  localStorage.setItem('module_' + item[1].code, item[1].name);
                  if (item[1].dashboard && item[1].dashboard.id) {
                    localStorage.setItem('module_' + item[1].code + '_dashboard', item[1].dashboard.id);
                  }
                  if (index == response.data.length - 1) {
                    document.getElementById('body').classList.remove('outside')
                    window.App.toastShow('success', 'Sikeres belépés!');
                    if (window.App) {
                      window.App.networkSelect();
                      window.App.loadReceiptGroups();
                      window.App.setState({ loggedIn: true });
                    }
                    //setTimeout(function () {
                    window.location.replace('/#/');
                    window.App.setState({ loggedIn: true });
                    window.App.forceUpdate()
                    window.App.setState({loggedIn: true})
                    if (localStorage.getItem('userToken') && process.env.REACT_APP_SUBSCRIPTION_MESSAGES === "enabled") {
                      NetworkSubscriptionMessageService()
                        .then(response => {
                          window.App.setState({
                            subscriptionMessages: response.data
                          })
                        })
                        .catch(error => {
                          // window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                        })
                    }
                    //window.location.reload() // TODO
                    //}, 2000)
                  }
                })
              })
              .catch(error => {
                window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                setLoading(false)
              })
          })
          .catch(error => {
            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
            setLoading(false)
          })
      })
      .catch(function (error) {
        setFormData({
          username: data.username,
          password: ''
        });
        setLoginError(true);
        setTimeout(function () {
          document.getElementById('password').focus();
        }, 1500);
        setLoading(false);
      })
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    document.title = 'Bejelentkezés' + ' - ' + process.env.REACT_APP_TITLE;
    document.getElementById('body').classList.add('outside')
    setTimeout(function () {
      document.getElementById('username').focus()
    }, 500)
  }, []);

  return (
    <div className="LoginPage p-component p-p-3">
      <img src={require("../.." + process.env.REACT_APP_LOGO_FILE).default} className="p-d-block p-my-5 p-mx-auto"/>
      <Panel headerTemplate={
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4 p-xl-6"}>
            <h3>
              <i className={"pi pi-user"}></i> Bejelentkezés
            </h3>
          </div>
        </div>
      } className={""}>
        <Form onSubmit={onSubmit}
              className="p-d-block p-mt-5 p-mx-auto"
              initialValues={formData}
              validate={validate} render={({handleSubmit, submitting}) => (
          <form onSubmit={handleSubmit}>
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <Field name="username" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="username"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Email</label>
                    <span className="p-input-icon-right">
                    <i className="pi pi-envelope"/>
                    <InputText id="username"
                               {...input}
                               tabIndex={1}
                               value={formData.username}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   username: e.target.value
                                 })
                               }}
                               className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12"}>
                <Field name="password" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="password"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>Jelszó</label>
                    <Password id="password"
                              tabIndex={2}
                              {...input}
                              toggleMask
                              feedback={false}
                              value={formData.password}
                              onChange={(e) => {
                                setLoginError(false);
                                setFormData({
                                  ...formData,
                                  password: e.target.value
                                })
                              }}
                              className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                              {loginError ? (
                                <small className="p-error p-d-block p-mt-2">
                                  Bejelentkezés sikertelen, a megadott adatok nem megfelelőek.
                                </small>
                              ) : (
                                isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
                              )}
                  </div>
                )}/>
              </div>
            </div>
            {/*{process.env.REACT_APP_BRAND === 'trackie' &&*/}
            {/*<Message className={"w-100 p-mt-2"}*/}
            {/*         severity="warn"*/}
            {/*         text="2023. október 29. utáni első bejelentkezésedhez kérjük, hogy használd az elfelejtett jelszó funkciót!"></Message>*/}
            {/*}*/}
            <div className={"p-grid p-mt-2"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
                <Link to={"/password-reset"}>Elfelejtettem a jelszavam</Link>
                {process.env.REACT_APP_REGISTRATION === 'enabled' &&
                <>
                  <br/>
                  <Link to={"/registration"}>Regisztráció</Link>
                </>
                }
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="submit" label="Belépés" className="p-button-success" icon={"pi pi-check"}
                        loading={loading} disabled={submitting}/>
              </div>
            </div>
            <div className={"p-text-center p-mt-5"}>
              <span className={"p-text-secondary"}
                    dangerouslySetInnerHTML={{__html: process.env.REACT_APP_COPYRIGHT.replace('[[YEAR]]', new Date().getFullYear())}}></span>
            </div>
          </form>
        )}/>
      </Panel>
    </div>
  )
}
export default withTranslation('common')(LoginPage);
